@if (isLoading) {
  <div class="spinner-overlay">
    <mat-spinner></mat-spinner>
  </div>
}

<h1 class="title">Segmented Rock images</h1>

@if (!isLoading) {
<mat-card class="rock-images-card">
  <div class="rock-images-content">
    <mat-form-field appearance="outline">
      <mat-label>Search segmented rock images</mat-label>
      <input
        matInput
        [(ngModel)]="searchInput"
        (ngModelChange)="filterRockImageFiles()"
        placeholder="Enter rock image file name"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    @if (filteredRockFiles.length) {
    <div class="rock-images-header">
      <h2>Rock files</h2>
      <button
        class="btn btn-secondary icon-btn clear-selection-action"
        [disabled]="!selectedFile"
        (click)="clearListSelection()"
      >
        <mat-icon>close</mat-icon>
        <span>Clear selection</span>
      </button>
    </div>

    <div class="scroll">
      <table class="mat-elevation-z2 full-width">
        <thead>
        <tr>
          <th>File Name</th>
          <th class="resolution-col">Resolution<br/>(μm/voxel)</th>
          <th>Data Type</th>
          <th class="voxel-col">Voxels X</th>
          <th class="voxel-col">Voxels Y</th>
          <th class="voxel-col">Voxels Z</th>
          <th>Uploaded By</th>
          <th>Created At</th>
        </tr>
        </thead>
        <tbody>
          @for (file of filteredRockFiles; track file.fileName) {
            <tr
              (click)="onRowClick(file)"
              [class.selected]="file.fileName === selectedFile?.fileName"
            >
              <td>{{ file.fileName | removeExtension }}</td>
              <td class="resolution-col">{{ file.resolution ? (file.resolution | number : '1.2-2') : '-' }}</td>
              <td>{{ file.dataType ?? '-' }}</td>
              <td class="voxel-col">{{ file.voxelsX ?? '-' }}</td>
              <td class="voxel-col">{{ file.voxelsY ?? '-' }}</td>
              <td class="voxel-col">{{ file.voxelsZ ?? '-' }}</td>
              <td>{{ file.userName }}</td>
              <td>{{ file.createdAt | date : 'short' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    } @else if (rockFiles.length) {
    <div class="no-results">
      <mat-icon class="no-results-icon">info</mat-icon>
      <p>No data matching the filter value</p>
    </div>
    } @else {
    <div class="no-results">
      <mat-icon class="no-results-icon">info</mat-icon>
      <p>No rock file images available</p>
    </div>
    }
  </div>

  <div class="rock-images-actions">
    <button
      class="btn btn-primary icon-btn"
      type="button"
      (click)="openUploadDialog()"
    >
      <mat-icon>backup</mat-icon>
      <span>Upload Rock image</span>
    </button>

    <div class="existing-file-actions">
      <button
        class="btn btn-secondary icon-btn"
        [disabled]="!selectedFile"
        (click)="openPreviewDialogForSelectedFile()"
      >
        <mat-icon>visibility</mat-icon>
        <span>Preview Rock image</span>
      </button>
      <button
        class="btn btn-warn icon-btn"
        [disabled]="!selectedFile"
        (click)="confirmDeleteRockImageFile()"
      >
        <mat-icon>delete</mat-icon>
        <span>Delete Rock image</span>
      </button>
    </div>
  </div>
</mat-card>
}
